<style lang="scss" scoped>
.slide-5 {
  background-image: url("../../../assets/module2/slide5/background-01.jpg");
  background-size: cover;
  background-position: center;
  padding-top: 90px;
  padding-left: 80px;
  padding-right: 80px;
  height: calc(100% - 90px);
  .heading {
    display: flex;
    flex-direction: row;
    margin-top: 100px;

    .heading-button {
      width: 225px;
      flex-shrink: 0;
      img {
        transform: scale(1.6);
        padding-top: 30px;
      }
    }
  }
  .heading2,
  .heading3 {
    text-align: right;
  }
  .heading2 {
    padding-right: 30px;
  }
  .block-text {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
  }
  video {
    outline: none !important;
    position: absolute;
    top: 132px;
    left: 1037px;
    z-index: 1;
    width: 820px;
    height: 459px;
    background: black;
    border-radius: 23px;
  }
}
</style>

<template>
  <div class="slide-5">
    <transition name="fadeRight" appear>
      <img
        class="delay-3 block-text"
        v-show="slideIndex == 4"
        src="@/assets/module2/slide5/video-01.png"
      />
    </transition>
    <div class="pages">
      <div class="page page-left">
        <transition name="fadeUp" appear>
          <div class="delay-1" v-show="slideIndex == 4">
            <p>{{ $t("module2.slide5.precopy") }}</p>
          </div>
        </transition>
        <transition name="fadeUp" appear>
          <div v-show="slideIndex == 4" class="heading delay-2">
            <div class="heading-text">
              <h1 class="heading1" v-html="$t('module2.slide5.heading1')"></h1>
              <h1 class="heading2" v-html="$t('module2.slide5.heading2')"></h1>
              <h1 class="heading3" v-html="$t('module2.slide5.heading3')"></h1>
            </div>
            <div class="heading-button">
              <a
                href=""
                class="button"
                @click.prevent="playVideo(videoID)"
                target="_blank"
              >
                <img
                  class="delay-8"
                  v-show="slideIndex == 4"
                  src="@/assets/module2/slide5/play_button.svg"
                />
              </a>
            </div>
          </div>
        </transition>
      </div>
      <div class="page page-right">
        <transition name="fade">
          <video
            v-if="showVideo"
            :src="videoURL"
            autoplay
            controls
            ref="video"
          ></video>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { log } from "../../../utils/log";
import vidEnd from "../../../utils/vid";

export default {
  data() {
    return {
      showVideo: false,
      videoURL:
        window?.CF_EBOOK_VARS?.videos?.book_2_video_1?.hd_large?.url ||
        "https://player.vimeo.com/external/404586820.hd.mp4?s=017fed36e8cc7fe4b44dd8ce7a1e6b62d928840e&profile_id=174&autoplay=1",
      videoID:
        window?.CF_EBOOK_VARS?.videos?.book_2_video_1?.video_id || "test_id"
    };
  },
  props: ["slideIndex"],
  methods: {
    playVideo(id) {
      log.videoView(id);
      this.showVideo = true;
      vidEnd(this);
    }
  }
};
</script>
